module.exports = __webpack_public_path__ + "media/finvid.662fea1a.mp4";